import React from "react";
import { FiRefreshCcw, FiRotateCcw, FiSearch } from "react-icons/fi";

import AdminButton from "../../_shared/ui/AdminButton";

import {
  SERVICE_CATEGORY_SUGGESTIONS,
  SERVICE_GPS_OPTIONS,
  SERVICE_LIMIT_OPTIONS,
  SERVICE_PUBLIC_OPTIONS,
  SERVICE_STATUS_OPTIONS,
  SERVICE_TYPE_OPTIONS,
} from "../data/servicesMunicipauxAdminData";

export default function ServicesMunicipauxFiltersPanel({
  q,
  categorie,
  typeFilter,
  stateFilter,
  publicFilter,
  withGps,
  limit,
  onChangeQ,
  onChangeCategorie,
  onChangeTypeFilter,
  onChangeStateFilter,
  onChangePublicFilter,
  onChangeWithGps,
  onChangeLimit,
  onSubmit,
  onReset,
  onRefresh,
  loading,
}) {
  return (
    <section className="mt-5 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="grid gap-4 xl:grid-cols-[1fr_260px_220px]">
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Rechercher un service
            </label>

            <div className="mt-2 flex min-h-12 items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 transition focus-within:border-sky-400 focus-within:bg-white focus-within:ring-4 focus-within:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:focus-within:border-sky-500 dark:focus-within:ring-sky-500/10">
              <FiSearch className="text-slate-400" />

              <input
                value={q}
                onChange={(event) => onChangeQ(event.target.value)}
                placeholder="Nom du service, téléphone, email..."
                className="h-11 min-w-0 flex-1 bg-transparent text-sm font-medium text-slate-800 outline-none placeholder:text-slate-400 dark:text-slate-100"
              />
            </div>
          </div>

          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Catégorie
            </label>

            <input
              value={categorie}
              onChange={(event) => onChangeCategorie(event.target.value)}
              placeholder="Animation, Accueil..."
              list="service-categories"
              className="mt-2 min-h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            />

            <datalist id="service-categories">
              {SERVICE_CATEGORY_SUGGESTIONS.map((category) => (
                <option key={category} value={category} />
              ))}
            </datalist>
          </div>

          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Type
            </label>

            <select
              value={typeFilter}
              onChange={(event) => onChangeTypeFilter(event.target.value)}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              {SERVICE_TYPE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid gap-4 lg:grid-cols-[180px_180px_180px_160px_1fr] lg:items-end">
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Statut
            </label>

            <select
              value={stateFilter}
              onChange={(event) => onChangeStateFilter(event.target.value)}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              {SERVICE_STATUS_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Visibilité
            </label>

            <select
              value={publicFilter}
              onChange={(event) => onChangePublicFilter(event.target.value)}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              {SERVICE_PUBLIC_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              GPS
            </label>

            <select
              value={withGps}
              onChange={(event) => onChangeWithGps(event.target.value)}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              {SERVICE_GPS_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Affichage
            </label>

            <select
              value={limit}
              onChange={(event) => onChangeLimit(Number(event.target.value))}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              {SERVICE_LIMIT_OPTIONS.map((value) => (
                <option key={value} value={value}>
                  {value} / page
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-wrap gap-2 lg:justify-end">
            <AdminButton
              type="submit"
              icon={FiSearch}
              variant="dark"
              loading={loading}
            >
              Rechercher
            </AdminButton>

            <AdminButton
              icon={FiRefreshCcw}
              variant="secondary"
              onClick={onRefresh}
              loading={loading}
            >
              Actualiser
            </AdminButton>

            <AdminButton icon={FiRotateCcw} variant="ghost" onClick={onReset}>
              Réinitialiser
            </AdminButton>
          </div>
        </div>
      </form>
    </section>
  );
}